import { useState } from "react";

import { Form } from "react-bootstrap";

import PropTypes from "prop-types";
import DashboardContext from "../../Context";
import { useContext } from "react";
/**
 * این کامپوننت برای اینپوت های عددی است
 */
export default function InputNumber({
  label,
  Placeholder,
  name,
  defaultValue,
  handelValue,
  disabled,
  maxLength,
  autoComplete,
  max = 0,
  noHelper = false,
  isPeriod = false,
}) {
  const { setNewPeriodTime } = useContext(DashboardContext);

  const [error, setError] = useState("");

  const [colorerror, setColorerror] = useState("");

  // const [previusValue, setPreviusValue] = useState(0);

  const pattern = isPeriod
    ? new RegExp("^\\+?[1-9][0-9]*$")
    : new RegExp("[+-]?([0-9]*[.])?[0-9]+");

  const hedelonCheng = (event) => {
    if (event.target.value) {
      const vlaue = event.target.value;

      if (pattern.test(vlaue)) {
        if (vlaue.length < 1) {
          setError("اطلاعات را کامل وارد کنید");
          setColorerror("red");
        }
        if (max && vlaue > max) {
          setError(`مقدار ورودی میبایست کمتر از ${max} باشد.`);
          setColorerror("red");
        } else {
          !noHelper && setError("اطلاعات قابل ثبت است");
          setColorerror("green");
          handelValue(name, vlaue);
        }
      } else {
        setError("اطلاعات فقط به عدد قابل ثبت است");
        setColorerror("red");
      }
    } else {
      setError("");
      setColorerror("");
      handelValue(name, null);
    }
  };

  return (
    <Form.Group>
      <div className='d-flex'>
        {label ? <Form.Label>{label}</Form.Label> : null}
      </div>
      <Form.Control
        disabled={disabled}
        type='text'
        dir='ltr'
        maxLength={maxLength}
        autoComplete={autoComplete ? "off" : "on"}
        placeholder={Placeholder ? Placeholder : ""}
        name={name ? name : ""}
        defaultValue={defaultValue ? defaultValue : ""}
        // onKeyDown={hedelonCheng} />
        onChange={hedelonCheng}
      />

      {error ? (
        <Form.Text style={{ color: colorerror }}>{error}</Form.Text>
      ) : null}
    </Form.Group>
  );
}
InputNumber.propTypes = {
  /**لیبل اینپوت است */
  label: PropTypes.string,
  /**برای ارسال مقدار اولیه برای اینپوت است */
  defaultValue: PropTypes.number,
  /** مقدار هلدر اینپوت است */
  Placeholder: PropTypes.string,
  /** نام اینپوت است */
  name: PropTypes.string,
  /** ارسال مقدار اینپوت به بالا است */
  handelValue: PropTypes.func,
};
